/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/**
 * The environments the notice is developed and reviewed in: local, plus the deployed
 * development and test ones.
 *
 * Build mode cannot tell these apart, because every deployed environment runs a
 * production build — a `NODE_ENV` check would leave the module's non-production
 * behavior working on a laptop and nowhere else, which is the opposite of what a
 * deployed review environment needs.
 *
 * Named environments rather than "not production" so an environment that sets the
 * variable to nothing at all is treated as production. `config/demo/prod.js` is
 * exactly that, and both behaviors this gates fail worse in the visitor's direction
 * than in the developer's: a console warning nobody reads, or a blocking dialog a
 * URL can summon.
 */
const developerEnvironments = new Set(['local', 'development', 'test']);

/**
 * Internal. True in the environments where the module does things it would never do
 * for a visitor — warn about its own misconfiguration, and let a query parameter
 * raise the notice.
 */
export function isDeveloperEnvironment() {
    return developerEnvironments.has(process.env.REACT_AXE_ENV ?? '');
}
